// Contenido centralizado de Red Mercadotecnia (extraído del documento oficial).
// Modular para facilitar futuras integraciones (chatbots IA, dashboards, CMS).

export const BRAND = {
  name: "RED Mercadotecnia",
  logo: "https://customer-assets.emergentagent.com/job_b2b-tech-showcase/artifacts/0xaf5lm1_red.png",
  tagline:
    "Inteligencia de Mercado · Validación Comercial · Estrategia Digital para Sectores de Alta Tecnología",
  location: "Zapopan, Jalisco, México",
  website: "www.redmercadotecnia.com",
};

export const HERO = {
  eyebrow: "Inteligencia de Mercado · Validación Comercial · Estrategia Digital",
  headline: "Certeza comercial para tecnología compleja.",
  subtitle:
    "Llevamos tus innovaciones al mercado con certidumbre y estrategia. Cuando la tecnología es compleja, la claridad comercial es tu mayor ventaja competitiva.",
  cta: "Explorar metodología",
  stats: [
    { value: "25", suffix: "", label: "Años de experiencia" },
    { value: "1,000", suffix: "+", label: "Proyectos validados" },
  ],
};

export const QUIENES_SOMOS = {
  eyebrow: "Quiénes somos",
  title: "25 años conectando innovación con el mercado",
  description:
    "Red Mercadotecnia es una firma especializada en transformar datos comerciales en ventajas competitivas sostenibles. Durante más de dos décadas, hemos acompañado a empresas de sectores tecnológicos en la validación de sus productos, la comprensión de sus mercados y el diseño de estrategias comerciales que reducen el riesgo y aceleran el crecimiento.",
  pillars: [
    {
      icon: "Target",
      title: "Marketing Estratégico",
      description:
        "Metodologías probadas para posicionar innovaciones complejas en mercados competitivos y altamente especializados.",
    },
    {
      icon: "Microscope",
      title: "Investigación Avanzada",
      description:
        "Rigor analítico para identificar el Market Fit óptimo antes, durante y después del lanzamiento de productos tecnológicos.",
    },
    {
      icon: "ShieldCheck",
      title: "Reducción de Riesgo",
      description:
        "Validación comercial que mitiga la incertidumbre en el desarrollo y comercialización de soluciones de alta tecnología.",
    },
  ],
};

export const METODOLOGIA = {
  eyebrow: "Metodología",
  title: "Rigor metodológico en investigación y validación",
  description:
    "Nuestro proceso de investigación especializado se estructura en cuatro pilares que garantizan una comprensión integral del mercado, el consumidor y la competencia. Cada etapa genera insights accionables que alimentan directamente la estrategia comercial.",
  stages: [
    {
      number: "01",
      title: "Vigilancia Comercial",
      description:
        "Análisis de tendencias globales, adopción de tecnologías emergentes y mapeo de la demanda actual para anticipar oportunidades de mercado antes que la competencia.",
    },
    {
      number: "02",
      title: "Benchmarking Competitivo",
      description:
        "Evaluación profunda de competidores, modelos de negocio, esquemas de precios y posicionamiento de marca para identificar brechas y ventajas diferenciales.",
    },
    {
      number: "03",
      title: "Análisis del Consumidor Tecnológico",
      description:
        "Investigación cualitativa y cuantitativa para entender barreras de adopción, motivadores de compra y perfiles de decisión en entornos B2B e industriales.",
    },
    {
      number: "04",
      title: "Estrategia de Go-to-Market",
      description:
        "Diseño de la hoja de ruta comercial, selección de canales de distribución y construcción de mensajes clave para acelerar las ventas y maximizar el retorno.",
    },
  ],
};

export const SECTORES = {
  eyebrow: "Especialización sectorial",
  title: "Marketing de base tecnológica",
  description:
    "La complejidad técnica de los productos de alta tecnología exige una capacidad única: traducir tecnicismos en propuestas de valor comerciales claras y persuasivas. Red Mercadotecnia domina este lenguaje, conectando soluciones avanzadas con compradores B2B e industriales que toman decisiones basadas en datos.",
  sectorsTitle: "Sectores que dominamos",
  sectors: [
    "Software empresarial y SaaS",
    "Automatización industrial",
    "Sistemas inteligentes e IoT",
    "Innovaciones con Inteligencia Artificial",
    "Monitoreo digital y analítica avanzada",
  ],
  advantageTitle: "Nuestra ventaja diferencial",
  advantage:
    "No somos una agencia generalista. Entendemos los ciclos de venta largos, los comités de compra técnicos y los argumentos racionales que mueven decisiones en entornos industriales y corporativos de alta complejidad. Nuestros equipos combinan experiencia en marketing con formación técnica para hablar el mismo idioma que tus clientes.",
};

export const TRAYECTORIA = {
  eyebrow: "Trayectoria",
  title: "Experiencia y marcas que confían en nosotros",
  description:
    "Más de 1,000 proyectos comerciales validados a lo largo de 25 años respaldan nuestra reputación como socios estratégicos de empresas líderes en sectores industriales, tecnológicos y corporativos. Nuestra cartera de clientes refleja la confianza que las organizaciones depositan en nuestra capacidad para generar resultados medibles.",
  metrics: [
    {
      value: 25,
      suffix: "",
      label: "Años de Experiencia",
      detail: "Trayectoria ininterrumpida en marketing estratégico e investigación de mercados.",
    },
    {
      value: 1000,
      suffix: "+",
      label: "Proyectos Validados",
      detail: "Estudios y estrategias comerciales ejecutados con resultados comprobados.",
    },
    {
      value: 4,
      suffix: "",
      label: "Pilares Metodológicos",
      detail: "Un framework propio de investigación y validación comercial integral.",
    },
  ],
  clientsTitle: "Clientes destacados",
  clients: [
    {
      name: "Evans Premium HD",
      logo: "https://customer-assets.emergentagent.com/job_b2b-tech-showcase/artifacts/innrxgae_image.png",
    },
    {
      name: "Adaflex Sistemas",
      logo: "https://customer-assets.emergentagent.com/job_b2b-tech-showcase/artifacts/ol1xnck2_image.png",
    },
    {
      name: "Vitecsa",
      logo: "https://customer-assets.emergentagent.com/job_b2b-tech-showcase/artifacts/w11qrkp4_image.png",
    },
    {
      name: "USEM",
      logo: "https://customer-assets.emergentagent.com/job_b2b-tech-showcase/artifacts/9v21fn58_image.png",
    },
  ],
};

export const MARQUEE_ITEMS = [
  "Inteligencia de Mercado",
  "Validación Comercial",
  "Estrategia Digital",
  "Tech Marketing B2B",
  "Reducción de Riesgo",
  "Go-to-Market",
];

export const FOOTER = {
  closing: "Certeza comercial para tus proyectos",
  closingText:
    "Llevamos tus innovaciones al mercado con certidumbre y estrategia. Cuando la tecnología es compleja, la claridad comercial es tu mayor ventaja competitiva.",
  columns: [
    { title: "Ubicación", value: "Zapopan, Jalisco, México" },
    { title: "Sitio Web", value: "www.redmercadotecnia.com" },
  ],
};

export const NAV_LINKS = [
  { label: "Quiénes somos", href: "#quienes-somos" },
  { label: "Metodología", href: "#metodologia" },
  { label: "Especialización", href: "#sectores" },
  { label: "Trayectoria", href: "#trayectoria" },
];
